import React, { PropTypes, PureComponent } from 'react';
import Checkbox from '../../../../shared/pureCheckbox';

import './styles.scss';

class FeatureList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler() {
    const currentValue = this.state.value; // true or false
    this.props.onCheckboxToggle(!currentValue);
    this.setState({
      value: !currentValue,
    });
  }

  render() {
    return (
      <div
        className={`feature-container
          ${this.state.value !== true ? 'disabled' : ''}`}
        onClick={this.onClickHandler}
      >
        <div
          className='title-copy'
        >
          {this.props.title}
        </div>
        <Checkbox
          value={this.state.value}
        />
        <div className="description-copy">{this.props.description}</div>
      </div>
    );
  }
}

FeatureList.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.bool,
  onCheckboxToggle: PropTypes.func,
};

export default FeatureList;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/features/featureList/index.jsx